import { FC } from 'react';
import { BaseImageList, LabeledValue, Modal } from 'melp-design/components';
import { ModalProps } from 'store/modal';
import { useTranslation } from 'react-i18next';

interface Props extends ModalProps {
  image: string;
  instructions: string;
  closeModal: (
    param?:
      | { action: 'CLOSE' }
      | { action: 'SET_EXAMPLE' }
      | { action: 'SELECT' },
  ) => void;
}

export const ImagePreviewModal: FC<Props> = ({
  closeModal,
  image,
  instructions,
}) => {
  const { t } = useTranslation();

  return (
    <Modal.Content
      actions={[
        {
          label: t('common.close'),
          variant: 'neutral-outline',
          onClick: () => closeModal(),
        },
        {
          label: t('ai.actions.generate_more_similar'),
          variant: 'secondary',
          onClick: () => closeModal({ action: 'SET_EXAMPLE' }),
        },
        {
          label: t('employees.select'),
          variant: 'primary',
          onClick: () => closeModal({ action: 'SELECT' }),
        },
      ]}
    >
      <BaseImageList cols={1} imageFit="full" items={[{ src: image }]} />
      <LabeledValue
        label={t('ai.images.instructions.label')}
        value={instructions}
      />
    </Modal.Content>
  );
};
